<template>
  <div>
    <portal to="entry_header">
      <h1 v-if="userAuthenticated">
        You are now logged in
      </h1>
      <h1 v-else>
        Register or log in to continue
      </h1>
    </portal>
    <div
      class="branding"
    >
      <span>www.soobahkdoinstitute.com</span>
    </div>

    <div
      v-if="userAuthenticated"
      class="uk-alert"
    >
      You are now logged in as <strong>{{ user.data.user_name }}</strong>.
    </div>

    <div
      v-if="!userAuthenticated"
      class="uk-grid"
    >
      <div class="uk-width-1-1 uk-margin-bottom">
        <div class="uk-alert">
          {{ $t('events.institute_authentication_explanation') }}
        </div>
      </div>
      <div
        class="uk-width-1-1 uk-margin-bottom"
      >
        <div
          v-if="entry && entry.data.registrar_role === 'school'"
          class="uk-alert uk-alert-warning"
        >
          <p>{{ $t('events.school_authentication_alert') }}</p>
        </div>
      </div>


      <div class="uk-width-1-1 uk-width-medium-8-10 uk-push-1-10">
        <Authenticate />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Mixins, Prop } from 'vue-property-decorator';
import UserModel, { create as createUser } from "../../models/UserModel";
import FormStep from "./FormStep";
import UserMixin from "./UserMixin";
import Authenticate from "../user/Authenticate.vue";

@Component({
  components: {
    Authenticate
  }
})
export default class UserAuthenticationFlow extends Mixins(FormStep, UserMixin) {
  @Prop() readonly studentDetails!: StudentDetails;

  @Prop() readonly guardianDetails!: GuardianDetails;

  @Prop() readonly addressDetails!: AddressDetails;

  @Prop() readonly registrarRole!: string;

  @Prop() readonly value!: number;

  error_code = 0;

  authenticatingUser = createUser();

  runValidation(): void {
    this.$emit('valid', this.userAuthenticated);
  }
}
</script>

<style scoped>
.abSelect {
  list-style-type: none;
}
.abSelect__radio {
  vertical-align: middle;
}
.abSelect__item {
  line-height: 2em;
}

</style>
